import {PermissionGuardBase} from "./permissionGuardBase.service";
import {IGuardMixin} from "./mixins/IGuardMixin";
import {NotLoggedInGuardMixin} from "./mixins/notLoggedInGuardMixin";

export class NotLoggedInGuard extends PermissionGuardBase {
  protected guardMixins: IGuardMixin[] = [new NotLoggedInGuardMixin(this.userService)];
}
